
      import { KatapultModel } from '../_resources/modules/katapult-model/KatapultModel.js';
      window.KatapultModel = KatapultModel;
    